
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Dodaj do swojego Ekranu Głównego, aby uzyskać bogate doświadczenie i łatwy dostęp.`,
's224cbcec014ef6b5': `Wybierz "Udostępnij"`,
's37a9e8aec5713460': `Więcej`,
's386eca8362ff6155': `Naciśnij Więcej, jeśli brak ikony Udostępnij`,
's4e1e10a6ca408245': `Naciśnij "Dodaj do Ekranu Głównego"`,
's6196153c4b0c1ea0': `Zainstaluj`,
's633502f7cff4f847': `Otwórz menu przeglądarki`,
's681e399d63311fba': `Pokaż galerię`,
's7f0591f08e318eda': `Naciśnij Więcej w menu Udostępnij`,
's8114bd55cae5a22b': `Wybierz "Dodaj do Docka"`,
's922329d6f6213590': `Dodaj do Docka`,
's9af56bf005b49c74': `Przewiń w dół do opcji "Dodaj do Ekranu Głównego"`,
'sa5ef80b4bb9b39f8': `Mniej`,
'sba52286c21552a4e': `Zainstaluj na swoim urządzeniu, aby uzyskać bogate doświadczenie i łatwy dostęp.`,
'sc16e00a7a8b2fde2': `Wstecz`,
'scdaf4bbff76674c8': `Dodaj do Ekranu Głównego`,
'se0e473adfda8066c': `Otwórz w swojej głównej przeglądarce`,
'se740f75b95a51807': `Dodaj do swojego Docka, aby uzyskać bogate doświadczenie i łatwy dostęp.`,
'sfea652f6580ff086': `Ta strona posiada funkcje aplikacji.`,
    };
  